import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  loadReceipts,
  saveReceipts,
  deleteReceipts,
  clearAjaxCall
} from '../actions/Receipts'
import { loadMembers } from '../actions/Members'
import { loadCourses } from '../actions/Courses'

import DualRing from './DualRing'
import Error from './Error'
import AjaxSpinner from './AjaxSpinner'

import ReceiptDetails from './Receipts/ReceiptDetails'
import EditReceipt from './Receipts/EditReceipt'
import DeleteReceipt from './Receipts/DeleteReceipt'

import { grant } from './Utils/Service'

import { paymentTypes } from '../options.json'

const initialState = {
  showDelete: false,
  showEdit: false,
  receipt: {},
  search: '',
  search_course: '',
  search_subscription: '',
  search_payment: ''
}

class Receipts extends Component {
  constructor() {
    super()
    this.showDelete = this.showDelete.bind(this)
    this.showEdit = this.showEdit.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.state = initialState
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.hideModal()
    }
  }
  componentWillMount() {
    if (this.props.receipts.list === null) {
      this.reloadReceipts()
    }
    if (this.props.members.list === null) {
      this.props.loadMembers()
    }
    if (this.props.courses.list === null) {
      this.props.loadCourses()
    }
  }
  showDelete(receipt) {
    this.setState({ showDelete: true, receipt })
  }
  showEdit(receipt) {
    this.setState({ showEdit: true, receipt })
  }
  newReceipt(subscription) {
    this.setState({
      showEdit: true,
      receipt: {
        id: null,
        subscription,
        number: '',
        account_holder: '',
        amount: '',
        causal: '',
        emission_date: '',
        payment_mode: '',
        notes: ''
      }
    })
  }
  hideModal() {
    this.setState({
      showDelete: false,
      showEdit: false
    })
  }
  reloadReceipts() {
    this.props.loadReceipts()
    this.props.loadMembers()
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.receipts.ajaxSpinner &&
      !this.props.receipts.ajaxSpinner &&
      this.props.receipts.ajaxStatus === null
    ) {
      this.hideModal()
      this.props.loadMembers()
    }
    if (
      prevProps.receipts.ajaxSpinner &&
      !this.props.receipts.ajaxSpinner &&
      this.props.receipts.ajaxStatus !== null
    ) {
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    }
  }
  filterList(list) {
    if (list === null) {
      return null
    }

    return list
      .filter((item) => {
        return this.state.search_course === ''
          ? true
          : item.course_id.toString() === this.state.search_course
      })
      .filter(
        (el) =>
          el.number.toString().indexOf(this.state.search.toLowerCase()) >= 0 ||
          el.cumulative
            .toLowerCase()
            .indexOf(this.state.search.toLowerCase()) >= 0 ||
          el.account_holder_name_surname
            .toLowerCase()
            .indexOf(this.state.search.toLowerCase()) >= 0
      )
      .filter((item) => {
        return this.state.search_payment === ''
          ? true
          : item.payment_mode.toString() === this.state.search_payment
      })
      .filter((item) => {
        return this.state.search_subscription === ''
          ? true
          : item.subscription.toString() === this.state.search_subscription
      })
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  render() {
    const { list, last, error, loading, ajaxSpinner } = this.props.receipts
    const filteredList = this.filterList(list)
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Ricevute</div>
          <div className='ph-descr'>
            <ul className='ul-filter'>
              <li>
                <input
                  type='text'
                  placeholder='Cerca ricevute'
                  onChange={(event) =>
                    this.setState({ search: event.target.value })
                  }
                  value={this.state.search}
                />
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_course: event.target.value })
                  }
                  value={this.state.search_course}
                >
                  <option value=''>Tutti i corsi</option>
                  {this.props.courses.list !== null &&
                    this.props.courses.list.map((o, index) => {
                      return (
                        <option key={index} value={o.id}>
                          {o.name}
                        </option>
                      )
                    })}
                </select>
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_payment: event.target.value })
                  }
                  value={this.state.search_payment}
                >
                  <option value=''>Tutti i tipi di pagamento</option>
                  {paymentTypes.map((o, index) => {
                    return (
                      <option key={index} value={o.value}>
                        {o.label}
                      </option>
                    )
                  })}
                </select>
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_subscription: event.target.value })
                  }
                  value={this.state.search_subscription}
                >
                  <option value=''>Tutti i tipi di ricevuta</option>
                  <option value='true'>Quota associativa</option>
                  <option value='false'>Ricevuta</option>
                </select>
              </li>
            </ul>
          </div>
          <ul className='ph-trend'>
            {last !== null && last.number !== '' && (
              <ul className='trend'>
                <li className='group'>numero Ultima ricevuta:</li>
                <li>{last.number}</li>
              </ul>
            )}
            {last !== null && last.number !== '' && (
              <ul className='trend'>
                <li className='group'>data Ultima ricevuta:</li>
                <li>{moment.unix(last.emission_date).format('ll')}</li>
              </ul>
            )}
          </ul>
          <ul className='ph-btn'>
            {grant() && (
              <li>
                <button
                  onClick={() => this.newReceipt(true)}
                  className='lnk-tools'
                >
                  <i className='fas fa-handshake'></i> quota associativa
                </button>
              </li>
            )}
            {grant() && (
              <li>
                <button
                  onClick={() => this.newReceipt(false)}
                  className='lnk-tools'
                >
                  <i className='fas fa-receipt'></i> ricevuta
                </button>
              </li>
            )}
            <li>
              <button
                onClick={() => this.reloadReceipts()}
                className='lnk-tools'
              >
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          <div className='ph-count'>
            {filteredList !== null &&
              filteredList.length +
                (filteredList.length === 1 ? ' risultato' : ' risultati')}
            {filteredList === null && <i className='fas fa-sync fa-spin'></i>}
          </div>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        {filteredList !== null &&
          filteredList
            .sort((a, b) => {
              return b.emission_date - a.emission_date || b.id - a.id
            })
            .map((r, index) => {
              return (
                <ReceiptDetails
                  key={index}
                  receipt={r}
                  showDelete={this.showDelete}
                  showEdit={this.showEdit}
                />
              )
            })}
        {this.state.showEdit && (
          <EditReceipt
            receipt={this.state.receipt}
            hideModal={this.hideModal}
          />
        )}
        {this.state.showDelete && (
          <DeleteReceipt
            receipt={this.state.receipt}
            hideModal={this.hideModal}
          />
        )}
        {ajaxSpinner && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadReceipts,
  saveReceipts,
  deleteReceipts,
  clearAjaxCall,
  loadMembers,
  loadCourses
})(Receipts)



// WEBPACK FOOTER //
// ./src/components/Receipts.js